import BaseService from "../BaseService";

class ProductCategoryService extends BaseService {
    list = async ({ info } = {}) => {
        return await this._api.get("/product_category/list", { params: { info } });
    };

    get = async (id) => {
        return await this._api.get(`/product_category/get`, { params: { id } });
    };

    create = async ({ name }) => {
        return await this._api.post(`/product_category/create`, { name });
    };

    update = async ({ id, name, sort_order, is_visible }) => {
        return await this._api.post(`/product_category/update`, { id, name, sort_order, is_visible });
    };

    delete = async (id) => {
        return await this._api.post(`/product_category/delete`, { id });
    };
}

export default ProductCategoryService;
